var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Select } from '@ngxs/store';
import { DriveState } from '../../state/drive-state';
import { Observable } from 'rxjs';
import { Settings } from '../../../../common/core/config/settings.service';
var AvailableSpaceIndicatorComponent = /** @class */ (function () {
    function AvailableSpaceIndicatorComponent(settings) {
        this.settings = settings;
    }
    AvailableSpaceIndicatorComponent.prototype.billingEnabled = function () {
        return this.settings.get('billing.enable');
    };
    __decorate([
        Select(DriveState.userSpaceUsed),
        __metadata("design:type", Observable)
    ], AvailableSpaceIndicatorComponent.prototype, "spaceUsed$", void 0);
    __decorate([
        Select(DriveState.userSpaceAvailable),
        __metadata("design:type", Observable)
    ], AvailableSpaceIndicatorComponent.prototype, "spaceAvailable$", void 0);
    __decorate([
        Select(DriveState.spaceUsedPercent),
        __metadata("design:type", Observable)
    ], AvailableSpaceIndicatorComponent.prototype, "spaceUsedPercent$", void 0);
    return AvailableSpaceIndicatorComponent;
}());
export { AvailableSpaceIndicatorComponent };
